import { _LabelGameStatusBase } from './labelGameStatusBase'

export class _LabelGameStatusDefault extends _LabelGameStatusBase {
  cssType: 'default' = 'default'
  protected initPC(): this {
    this['--label-game-status-height'] = '0.2rem'
    this['--label-game-status-padding'] = '0.02rem 0.02rem 0.02rem 0.06rem'
    this['--label-game-status-z-index'] = 'initial'
    this['--status-text-font-size'] = '0.14rem'
    return this
  }
  protected initH5(): this {
    this['--label-game-status-height'] = '0.3rem'
    this['--label-game-status-padding'] = '0.02rem 0.02rem 0.02rem 0.08rem'
    this['--label-game-status-z-index'] = 'initial'
    this['--status-text-font-size'] = '0.2rem'
    return this
  }
}
